import React from 'react';
import { css } from 'aphrodite';
import COLORS from "../../../library/colors"
import ReactLoading from "react-loading"
import styles from './content-card-styles';

const ContentCardView = (props) => (
  <div className={css(styles.root)}>
    <div className={css(styles.title)}>{props.title}</div>
    <div className={css(styles.content)}>
      {props.isLoading && <div className={css(styles.loadingWrapper)}><ReactLoading className={css(styles.loader)} type={'spin'} color={COLORS.disabledButtonBg} height={50} width={50} /></div>}
      {!props.isLoading && props.children}
    </div>
  </div>
);

export default ContentCardView;



// WEBPACK FOOTER //
// ./src/components/common/content-card/content-card-view.js